import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IUser } from 'src/app/core/models/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { LanguageService } from 'src/app/core/services/language.service';
import { UserService } from 'src/app/core/services/user.service';
import { WhitelabelService } from 'src/app/core/services/whitelabel.service';

/**
 * @ignore
 */
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
})
export class NavigationComponent implements OnInit {
  user: IUser;
  language = 'en';
  showLanguages = false;
  logo: string = '../../../../assets/img/logo-white.svg';

  toggleUploadImage = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private languageService: LanguageService,
    private whitelabelService: WhitelabelService,
    private userService: UserService,
    public toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.user = user;
    });

    this.whitelabelService.logo.subscribe((logo) => {
      console.log('logo', logo);
      if (logo) this.logo = logo;
    });

    this.languageService.Language.subscribe((lang) => {
      console.log('lang: ' + lang);
      if (lang) {
        this.language = lang;
      }
    });

    let btn = document.getElementById('btn');
    let sidebar = document.querySelector('.sidebar');

    btn.onclick = function () {
      sidebar.classList.toggle('active');
    };
  }

  /**
   * toggle dropdown for languages
   */
  openDropdown() {
    this.showLanguages = !this.showLanguages;
  }

  openSidebar() {
    const sidebar = document.querySelector('.sidebar');
    const content = document.querySelector('.home_content');

    if (sidebar.classList.contains('show_sidebar')) {
      sidebar.classList.remove('show_sidebar');
      content.classList.remove('show_sidebar_home');
    } else {
      sidebar.classList.add('show_sidebar');
      content.classList.add('show_sidebar_home');
    }
  }

  /**
   *
   * @param language - selected language
   */
  useLanguage(language: string) {
    this.languageService.removeLanguage();
    localStorage.setItem('panelLang', JSON.stringify({ language }));
    this.languageService.setLanguage(language);
    window.location.reload();
  }

  /**
   *  Logout user
   */
  logout() {
    this.authService.logout();
    localStorage.removeItem('panelLang');
    this.router.navigate(['/login']);
  }

  url: any;
  file: any;

  openUploadImageModal() {
    this.toggleUploadImage = true; 
    this.file= '';
     this.url=''
  }
  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.file = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event) => { // called once readAsDataURL is completed
        this.url = event.target.result;
      }
    }
  }

  uploadFile() {
    const formData = new FormData();
    formData.append("image", this.file, this.file.name);
    this.userService.uploadProfileImage(this.user.id, formData).subscribe(res => {
      this.toggleUploadImage = false;
      this.user.profileImage = res.profileImage;
      this.toastr.success('You have successfully uploaded the image.');
    })
  }
}
